var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('orders',{attrs:{"title":_vm.title}}),_c('latest-orders')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }